import React from 'react'
import { Link } from 'react-router-dom';
import logoWhite from '../../Assets/img/logo_pressing360-white.png'
const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <>
            <footer className="modern-footer pt-5 mt-5 mb-3">
                <div className="container footer-content">
                    <div className="row g-4 mb-5">
                        {/* <!-- Company Info --> */}
                        <div className="col-lg-4 col-md-6">
                            <Link className="footer-logo d-block mb-4 ">
                                <img src={logoWhite} alt="" className='logo_main' />
                            </Link>
                            <p className="text-white mb-4">Gérez votre pressing avec une simplicité inégalée grâce à notre application intuitive. Suivez vos commandes en temps réel, automatisez vos tâches, et offrez une expérience client exceptionnelle.</p>
                            <ul className="contact-info mb-4">
                                <li>
                                    <i className="fas fa-map-marker-alt"></i>
                                    <span>Côte d'Ivoire, Abidjan Yopougon PMI </span>
                                </li>
                                <li>
                                    <i className="fas fa-phone"></i>
                                    <span>+225 07 88 89 89 98</span>
                                </li>
                                <li>
                                    <i className="fas fa-envelope"></i>
                                    <span>contact@elktech.com</span>
                                </li>
                            </ul>
                        </div>

                        {/* <!-- Quick Links --> */}
                        <div className="col-lg-4 col-md-6">
                            <h3 className="footer-title">Liens</h3>
                            <ul className="quick-links">
                                <li><a href="#softwaredetails">Fonctionnalité</a></li>
                                <li><a href="https://elktech-ci.com/">Apropos de nous</a></li>
                                <li><a href="#explanatoryvideo">Vidéo Explicative</a></li>


                                <li><a href="https://elktech-ci.com/solutions">Nos Solutions</a></li>
                                <li><a href="#pricing">Tarification</a></li>
                                <li><a href="https://academy.elktech-ci.com/">Nos Formations</a></li>
                                <li><a href="https://formation.pressing360.com/">Formations </a></li>
                                <li><a href="https://pressing360.com/conditions-utilisation">Cdu Pressing360</a></li>

                            </ul>
                        </div>

                        {/* <!-- Newsletter -->: */}
                        <div className="col-lg-4 col-md-12">
                            <h3 className="footer-title">Restez connecté</h3>
                            <p className="text-white mb-4">Abonnez-vous à notre newsletter et restez informé des dernières nouvelles et idées.</p>
                            <form className="mb-4">
                                <div className="mb-3">
                                    <input type="email" className="form-control newsletter-input" placeholder="Votre adresse email" />
                                </div>
                                <button type="submit" className="btn btn-subscribe text-white w-100">Abonnez-vous maintenant</button>
                            </form>
                            <div className="social-links">
                                <a href="facebook.com/elktech21" className="social-icon"><i className="fab fa-facebook-f"></i></a>
                                <a href="#" className="social-icon"><i className="fab fa-twitter"></i></a>
                                <a href="#" className="social-icon"><i className="fab fa-instagram"></i></a>
                                <a href="#" className="social-icon"><i className="fab fa-linkedin-in"></i></a>
                                <a href="#" className="social-icon"><i className="fab fa-youtube"></i></a>
                            </div>
                        </div>
                    </div>
                </div>

                {/* <!-- Footer Bottom --> */}
                <div className="footer-bottom">
                    <div className="container">
                        <div className="row py-4">
                            <div className="col-md-6 text-center text-md-start">
                                <p>&copy; {currentYear} <Link href="https://elktech-ci.com/">Elk-Tech Groupe</Link> . Tous droits réservés.</p>
                            </div>
                            <div className="col-md-6 text-center text-md-end">
                                <p>Made with <i className="fas fa-heart text-danger"></i> by <a href="https://elktech-ci.com/">Elk-Tech Groupe</a></p>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    )
}

export default Footer